export * from './src/velo-secrets-vault-v1-secret-secrets.universal.js';
